"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const client_1 = __importDefault(require("react-dom/client"));
const ErrorBoundary_1 = __importDefault(require("../../utility/ErrorBoundary"));
const Login_1 = __importDefault(require("./Login"));
const ResetPassword_1 = __importDefault(require("./ResetPassword"));
const cardReducer = (state, action) => {
    switch (action.type) {
        case "LOGIN":
            return action.type;
        case "RESET_PASSWORD":
            return action.type;
        default:
            return state;
    }
};
function App() {
    const [card, dispatchCard] = (0, react_1.useReducer)(cardReducer, "LOGIN");
    const siteKey = "6LfyZOInAAAAAPpAITnbMI4L4lA47rrDeD-iLUEl";
    const loadScript = (src) => {
        const script = document.createElement("script");
        script.src = src;
        document.body.appendChild(script);
    };
    // Add google recaptcha script
    react_1.default.useEffect(() => {
        loadScript(`https://www.google.com/recaptcha/api.js?render=${siteKey}`);
        loadScript("https://accounts.google.com/gsi/client");
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { style: { display: "flex", justifyContent: "center" }, "data-testid": "login-app-element", children: (0, jsx_runtime_1.jsxs)("div", { className: "login-box", children: [(0, jsx_runtime_1.jsxs)("div", { className: "login-logo", style: { color: "#892203" }, children: [(0, jsx_runtime_1.jsx)("a", { href: process.env.WOO_STORE_URL, children: (0, jsx_runtime_1.jsx)("img", { className: "img-fluid", src: "assets/img/4DControls.png", title: "4D Controls Logo", style: { width: "35%" } }) }), (0, jsx_runtime_1.jsx)("br", {})] }), (0, jsx_runtime_1.jsx)("div", { className: "card", children: (0, jsx_runtime_1.jsx)("div", { className: "card-body login-card-body", children: card === "LOGIN" ? ((0, jsx_runtime_1.jsx)(Login_1.default, { siteKey: siteKey, dispatchCard: dispatchCard })) : ((0, jsx_runtime_1.jsx)(ResetPassword_1.default, { dispatchCard: dispatchCard })) }) })] }) }));
}
exports.default = App;
const container = document.getElementById("login-root");
if (container) {
    const root = client_1.default.createRoot(container);
    root.render((0, jsx_runtime_1.jsx)(ErrorBoundary_1.default, { children: (0, jsx_runtime_1.jsx)(App, {}) }));
}
